import { render, staticRenderFns } from "./NonStandardCustomer.vue?vue&type=template&id=79b1f5fb&"
import script from "./NonStandardCustomer.vue?vue&type=script&lang=js&"
export * from "./NonStandardCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports